import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';

class ConfirmButton extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };

        this.action = (() => this.showModal(false));
    }

    showModal = (isOpen) => {
        this.setState({ isOpen: isOpen });
    }

    executeAction = () => {
        this.showModal(false);
        this.action();
    }

    render() {
        let newProps = { ...this.props }

        if (newProps.onClick != null && typeof (newProps.onClick) === 'function') {
            this.action = newProps.onClick;
            newProps.onClick = (() => this.showModal(true));
        }
        return (
            <>
                <Button {...newProps}>
                    {this.props.children}
                </Button>
                <Modal centered isOpen={this.state.isOpen}>
                    <ModalBody>
                        {this.props.body != null ? this.props.body : 'Are you sure you wish to proceed?'}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color={this.props.color != null ? this.props.color : 'Danger'}
                            onClick={this.executeAction}
                        >
                            {this.props.action != null ? this.props.action : 'Yes'}
                        </Button>
                        <Button onClick={() => this.setState({ isOpen: false })}>
                            {this.props.cancel != null ? this.props.cancel : 'Cancel'}
                        </Button>
                    </ModalFooter>
                </Modal>
            </>)
    }
};

export default ConfirmButton;